import { createNavigation } from 'next-intl/navigation';

import { routing } from './routing';

const navigation = createNavigation(routing);

// Legacy utility and account links can remain string-based while SEO-facing
// links migrate to typed pathname templates.
export const Link = navigation.Link as React.ComponentType<any>;
export const useRouter = navigation.useRouter as () => any;
export const { getPathname, redirect, usePathname } = navigation;
